import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../api-new/http';
import { appUrls } from '../../../api-new/urls';
import { contestListData, contestListError } from './actions';
import { CONTEST_LIST_FETCH } from './constants';
import { ContestListItem, ContestStatus } from './types';
import { SagaIterator } from 'redux-saga';

export function* ContestListSaga(): SagaIterator {
    try {
        const response = yield call(() => api.get(`${appUrls.tradeURL}/public-contests`));
        const rawItems = response?.data?.data || [];

        const mapped: ContestListItem[] = rawItems.map((item: any, index: number) => {

            const start = item.startDateTimeTime || item.startDateTime || item.start_time || '';
            const end = item.endDateTimeTime || item.endDateTime || item.end_time || '';

            return {
                contestId: Number(item.contestId ?? item.id ?? index + 1),
                name: String(item.name ?? item.contestName ?? `Contest ${index + 1}`),
                period: item.period || (start && end ? `${new Date(start).toLocaleString()} - ${new Date(end).toLocaleString()}` : ''),
                status: item.startDateTime && new Date(item.startDateTime).getTime() < new Date().getTime() ? "running" : item.endDateTime && new Date(item.endDateTime).getTime() > new Date().getTime() ? "upcoming" : "finished",
                bannerUrl:  item.banner 
            };
        });

        yield put(contestListData(mapped));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch contest list', error);
        yield put(contestListError(error));
    }
}

export function* rootContestListSaga(): SagaIterator {
    yield takeLatest(CONTEST_LIST_FETCH, ContestListSaga);
}


